// extracted by mini-css-extract-plugin
module.exports = {"xpaContainer":"Match_xpaContainer__jBEuX","div-gpt-ad-1663253151713-0":"Match_div-gpt-ad-1663253151713-0__d3igL"};